import { AppConfig } from '../app.config';
import { User } from '../models/user';
import { BaseService } from './BaseService';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

@Injectable()
export class HospitalsService extends BaseService {

  constructor(private http: Http, private config: AppConfig) {
    super();

    }

   getAll() {
    return this.http.get(this.config.apiUrl + '/hospitals/', this.jwt(true))
       .map(res => res.json());
  }

  getById(_id) {
    return this.http.get(this.config.apiUrl + '/hospitals/' + _id+'/', this.jwt(true))
       .map(res => res.json());
  }

  create(doctor) {
    return this.http.post(this.config.apiUrl + '/hospitals/', doctor, this.jwt(true));
  }

  update(doctor) {
    return this.http.put(this.config.apiUrl + '/hospitals/' + doctor._id, doctor, this.jwt(true));
  }

  delete(_id) {
    return this.http.delete(this.config.apiUrl + '/hospitals/' + _id+'/', this.jwt(true));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/hospitals.service.ts